/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для статуса корзины
   */
  app.CartStatusView = app.View.extend({
    el: '.cart-header',
    /**
     * @inheritDoc
     */
    run: function () {
      this.$emptyCartBlock = this.$('.cart-header-empty');
      this.$filledCartBlock = this.$('.cart-header-fill');
      this.$qty = this.$filledCartBlock.find('.count');
      this.$cartUnits = this.$('.cart-units');
      this.sumTemplate = app.helpers.TemplateHelper.getTemplate('#cart-status-sum');
      this.cartHeaderMinOrderSumTemplate = app.helpers.TemplateHelper.getTemplate('#cart-header-min-order-sum');
      this.listenTo(this.cart, 'update', this.update);
      this.listenTo(this.cart, 'currency-set', this.updateMinOrderSum);
      this.listenTo(this.cart, 'updatedMinSum', this.updateMinOrderSum);
      this.listenTo(this.settlement, 'sync', this.fetchAndUpdate);
      this.updateMinOrderSum();
    },
    /**
     * Обновляем данные из корзины.
     */
    fetchAndUpdate: function () {
      this.cart.fetch();
      this.listenToOnce(this.cart, 'sync', this.update);
    },
    /**
     * Запускаем методы обновления данных о корзине.
     */
    update: function () {
      this.updateCartStatus();
      this.updateQty();
      this.updateSum();
      this.updateUnitsWord();
      this.updateMinOrderSum();
    },

    /**
     * Обновляет количество товаров
     */
    updateQty: function () {
      this.$qty.html(this.cart.cartInfo.items_count);
    },

    /**
     * Обновляет склонение слова товар|товара|товаров в зависимости от количества в корзине
     */
    updateUnitsWord: function () {
      this.$cartUnits.html(
        app.helpers.DeclinationHelper.format(
          this.cart.cartInfo.items_count, ['товар', 'товара', 'товаров']
        )
      );
    },

    /**
     * Обновляет отображение корзины в шапке
     */
    updateCartStatus: function () {
      if (this.cart.cartInfo.items_count) {
        this.$emptyCartBlock.addClass('hide');
        this.$filledCartBlock.removeClass('hide');
      } else {
        this.$filledCartBlock.addClass('hide');
        this.$emptyCartBlock.removeClass('hide');
      }
    },

    /**
     * Обновляет сумму
     */
    updateSum: function () {
      var sumContainer = this.$('.js-cart-status-sum')
        ? this.$('.js-cart-status-sum')
        : this.$('.sum-integer').parent();

      sumContainer.html(this.sumTemplate({
        price: app.helpers.NumberHelper.numberWithoutZeroFraction(this.cart.cartInfo.sum),
        currentCurrency: this.cart.currency,
      }));
    },
    /**
     * Обновляет сумму минимального заказа, если сумма в корзине меньше ее, а также при смене валюты
     */
    updateMinOrderSum: function () {
      var minOrderSum = this.cart.minOrderSum,
        cartSum,
        // Минимальная сумма корзины для "Мелкого опта"
        minSumOrderForSmallWholesale = 1,
        isExclusion = this.cart.isExclusion;
      cartSum = this.cart.cartInfo.sum;
      //Скрывать информацию о минимальной сумме заказа в городах, где есть СП
      var isHideMinSumInfo = this.settlement && this.settlement.get('has_active_jp_purchase');
      if (
        cartSum < minOrderSum && this.cartHeaderMinOrderSumTemplate
        && minOrderSum > minSumOrderForSmallWholesale && !isHideMinSumInfo
      ) {
        minOrderSum = app.helpers.NumberHelper.fractionNumber(minOrderSum)[0];
        $('.min-order-sum-notice').replaceWith(this.cartHeaderMinOrderSumTemplate({
          minOrderSum: minOrderSum,
          isExclusion: isExclusion,
          currentCurrency: this.cart.currency,
        }));
      } else {
        $('.min-order-sum-notice').replaceWith('<span class="min-order-sum-notice example"></span>');
      }
    },
  });
})(jQuery);

}.call(window));